/* ============================================================
   ISJ – Feedback al agregar al carrito
   SOLO el latido del icono del bag. La animacion del boton la maneja
   el theme (animacion default). Este script no toca el carrito.
   ============================================================ */
(function () {
  var SEL_BUTTON = '.add_to_cart';

  function isVisible(el) {
    if (!el || el.offsetParent === null) return false;
    var cs = window.getComputedStyle(el);
    if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) return false;
    if (r.right <= 0 || r.bottom <= 0) return false;
    if (r.left >= (window.innerWidth || 0) || r.top >= (window.innerHeight || 0)) return false;
    return true;
  }

  function cartIcon() {
    var all = document.querySelectorAll('.mini_cart, a.mini_cart');
    for (var i = 0; i < all.length; i++) if (isVisible(all[i])) return all[i];
    return null;
  }

  function bump() {
    var t = cartIcon();
    if (!t) return;
    t.classList.remove('isj-bag-bump');
    void t.offsetWidth;
    t.classList.add('isj-bag-bump');
    setTimeout(function () { t.classList.remove('isj-bag-bump'); }, 600);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(SEL_BUTTON);
    if (!btn || btn.disabled) return;
    setTimeout(bump, 250);
  }, true);
})();
